import * as React from "react";

import clsx from "clsx";
import { NavLink as BaseNavLink, NavLinkProps } from "react-router-dom";

interface NavLinkPropsWithActiveStyle extends NavLinkProps {
  activeStyle?: React.CSSProperties;
  activeClassName?: string;
}

const NavLink = React.forwardRef<
  HTMLAnchorElement,
  NavLinkPropsWithActiveStyle
>(({ activeClassName, activeStyle, ...props }, ref) => {
  return (
    <BaseNavLink
      ref={ref}
      {...props}
      className={({ isActive }) =>
        clsx(props.className, isActive && activeClassName)
      }
      style={({ isActive }) => ({
        ...props.style,
        ...(isActive ? activeStyle : {}),
      })}
    />
  );
});

export default NavLink;
